import { fieldToCollabJSON } from '@databases/collab/convert/to-collab';
import {
  getOrderWithFallback,
  placeIdsInOrder,
  placeIdsRelativeToAnchor
} from '@databases/model/database';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';
import { setFieldVisibleInAllViews } from '../set-field-visible-in-all-views.ts';

export const addField: YJSChangeHandler<DatabaseChangeType.ADD_FIELD> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    if (change.index != null) {
      db.addFieldAt(change.field.id, fieldToCollabJSON(change.field, {}), change.index);
    } else {
      db.addFieldFromJSON(change.field.id, fieldToCollabJSON(change.field, {}));
    }

    const placement = change.viewPlacement;
    if (placement) {
      db.views.forEach((viewId) => {
        const order = getOrderWithFallback(db.fields, db.viewOrders[viewId]?.fieldOrder);
        const nextOrder =
          viewId === placement.currentViewId
            ? placeIdsRelativeToAnchor(
                order,
                [change.field.id],
                placement.anchorFieldId,
                placement.position
              )
            : placeIdsInOrder(order, [change.field.id], order.length);
        db.setViewFieldOrder(viewId, nextOrder);
      });
    }

    setFieldVisibleInAllViews(db, change.field.id, db.fields);
  });
};
